import { deleteJson, jsonPut, jsonPost, commonThinxHeaders } from '../api'
import { PAYMENT_METHOD_TYPE_CREDIT_CARD, PAYMENT_METHOD_TYPE_PAD } from 'auth/constants'

export const removeCreditCard = (accountKey, token, cardId) =>
    deleteJson(`${THINX_ACCOUNT_URL}/subscription/account/payment/method/${accountKey}/${cardId}`, undefined, {
        Authorization: `Bearer ${token}`,
        'X-Tenant': THINX_X_TENANT,
    }).catch(error => {
        throw new Error(error.message)
    })

export const setDefaultCreditCard = (accountKey, token, cardId) =>
    jsonPut(
        `${THINX_ACCOUNT_URL}/subscription/account/payment/method/default/${accountKey}/${cardId}`,
        undefined,
        undefined,
        commonThinxHeaders(token)
    ).catch(error => {
        throw new Error(error.message)
    })

export const saveCardData = (
    accountKey,
    token,
    { token: permanentToken, lastFour, expireMonth, expireYear, cardType, nameOnCard }
) =>
    jsonPost(
        `${THINX_ACCOUNT_URL}/subscription/account/payment/method/${accountKey}`,
        {
            token: permanentToken,
            lastFour,
            expireMonth,
            expireYear,
            cardType,
            nameOnCard,
            paymentMethodType: PAYMENT_METHOD_TYPE_CREDIT_CARD,
        },
        commonThinxHeaders(token)
    ).catch(error => {
        throw new Error(error.message)
    })

export const savePadData = (accountKey, token, data) =>
    jsonPost(
        `${THINX_ACCOUNT_URL}/subscription/account/payment/method/${accountKey}`,
        { ...data, paymentMethodType: PAYMENT_METHOD_TYPE_PAD, achAccountType: 'Checking', defaultInd: false },
        commonThinxHeaders(token)
    ).catch(error => {
        throw new Error(error.message)
    })
